export const document = {
  document_signataire: {
    title: 'Liste des collèges documents',
    fiche: {
      title: "Création d'un nouveau collège de document",
      edit_title: "Modification d'un collège de document",
    },
  },
  authority_signataire: {
    title: 'Liste des pouvoirs documents',
    fiche: {
      title: "Création d'un nouveau pouvoir de signature document",
      edit_title: "Modification d'un pouvoir de signature document",
    },
  },
  generation_document: {
    title: 'Génération Pouvoir',
    btn_generate: 'Générer',
    bank_placeholder: '- Banque -',
    gliss_placeholder: '- Faites glisser ici pour grouper -',
    flux_filter: '- Document -',
    pouvoir_filter: '- Pouvoir -',
    mandateUser_filter: '- Mandants physiques -',
    mandateCompany_filter: '- Mandants morales -',
    direct_mandate: 'Mandant direct',
    fiche: {
      bank: 'Banque',
      iban: 'IBAN',
      devise: 'Devise',
      pouvoir_bancaire: 'Pouvoir Bancaire',
      date_modif: 'Date de modification',
      flow_name: "Flux"
    },
  },
  validation_document: {
    title: 'Liste des Pouvoirs',
    btn_imprime: 'Imprimer',
    btn_sendsignatory: 'Envoi signataires',
    btn_signature: 'Valider',
    btn_attribut: 'Attribuer',
    btn_carton: 'Cartons de signatures',
    btn_identity: 'Pièces identités',
    message_confirm_attibute: "Voulez vous vraiment attribuer ce compte",
    column: {
      num: 'N°',
      state: 'Etat',
      account: 'Compte',
      society: 'Société',
      pouvoir: 'Pouvoir',
      currency: 'Devise',
      login: 'Login',
      date: 'Date',
      signatories: 'Signataire',
      bank: 'Banque',
      code: 'Code compte ',
      flow: 'Flux'
    },
    audit_validation: {
      date: 'Date',
      login: 'Login',
      action: 'Action',
    },
    actions: {
      upload: 'Charger document signé',
    }
  },
  sign_document: {
    title: 'Liste des signatures documents',
  },
  gestion_document: {
    table: {
      title: 'Liste des Signataires',
      tilte_send_mail_bank: 'Envoi email Banquier',
      tilte_send_mail_signataire: 'Envoi email Signataire',
      head_filtre_placeholder: '- Tous les collèges -',
      email_bank: "Email",
      icon_mail_bank: 'Envoyer email à banque',
      icon_mail_signataire: 'Envoyer email à signataire',
      culumn: {
        state: "Etat",
        login: 'Login',
        name: 'Nom',
        lastname: 'Prénom',
        mail: 'Email',
        numphone: 'N° mobile',
        date: 'Date de Validité',
        cn: 'CNI',
        passport: 'Passeport',
        signature: 'Signature',
        date_birth: 'Date de naissance',
        country_birth: 'Pays de naissance',
        place_birth: 'Lieu de naissance',
        nationality: 'Nationalité',
        num_cin: 'Numéro CIN',
        date_cin: 'Date validation',
        civility: 'Civilité',
        function: 'Fonction',
      }
    },

  },
  histo_document: {
    title: 'Liste des historiques documents',
    date_sign: 'Date Signature',
    date_envoi: 'Date Envoi Banque',
    date_recep: 'Date Réception',
    date_retour: 'Date Retour Banque',
    button_action: {
      title: 'Action',
      envoi: 'Envoi banque',
      retour: 'Validation banque',
      recep: 'Réception banque',
      refus: 'Refus banque',
    },
    send_bank_modal: {
      email: "Emails",
      bank: "Banque",
      subject: "Objet",
      send: "Envoyer"
    }
  },
  document_authority: {
    titles: {
      by_account: {
        generation: "Génération documents comptes",
        validation: "Liste de documents comptes",
      },
      by_company: {
        generation: "Génération documents sociétés",
        validation: "Liste de documents sociétés",
      },
    }
  },
  mandant: {
    title: "Liste des Mandants",
    filter: {
      societe: "Sociétés",
      societe_mandat: "Sociétés Mandant",
      mandant_pers: "Mandant Personnes physique",
      direct_mandant: "Mandant direct"
    },
    column: {
      state: "Etat",
      code: "Code",
      name: "Nom",
      pays: "Pays",
      ordre: "Ordre",
      type_lien: "Type Lien Mandant",
      name_mandat: "Nom Mandant",
      type_mandant: "Type Mandant",
      fonction: "Fonction",
      date_start: "Date début",
      date_end: "Date fin",
      action: "Actions",
    }
  }

}

